import NavBarWizardBaseCtrl from 'edge/platform/widgets/wizard/NavBarWizardBaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import moment from 'moment';
import 'moment-timezone';

export default ['$scope', '$interval', '$element', '$filter', 'StateUtils', '$state', '$location', '$q', '$cookies', 'SearchService', 'UserService', '$stateParams', '$injector', '$sanitize', 'UserInfoService', 'NavBarItems', 'PolicyService', '$rootScope', 'serverDown', function ($scope, $interval, $element, $filter, StateUtils, $state, $location, $q, $cookies, SearchService, UserService, $stateParams, $injector, $sanitize, UserInfoService, NavBarItems, PolicyService, $rootScope, serverDown) {
    $scope.claimsFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayclaims === 'true';
    var infoCenterFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayAnalytics === 'true';

    var baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
    var ctrl = Object.create(baseNavbarCtrl);
    ctrl.init = function () {
        initialiseScopeLevelVariables();
        $scope.menuItems = NavBarItems;
        $scope.isAgent = UserInfoService.isAgent();
        /**DEF0617- Get current user's first and last name **/
        console.log("before service call");
        console.log($rootScope.authData.userData);
        //DEF1903-Performance-UI-Portal-PE-Repeated Calls in the same request - identified in Performance Test
        var fullNames = 'Hello! ';
        $scope.fullName = fullNames.concat($rootScope.authData.userData.name);
        $rootScope.firstName = $rootScope.authData.userData.given_name;
        $rootScope.lastName = $rootScope.authData.userData.family_name;
        /*PolicyService.getDisplayName().then(function(userdetails){
        	console.log("started call");
            $scope.userResultsPromise = userdetails.fullName;
            $rootScope.firstName = userdetails.firstName;
            $rootScope.lastName = userdetails.lastName;
            console.log("inside service call");
            //DEF1903
            UserFullNameService.setter(userdetails);
            console.log("after userfullname service call");
            var fullNames = 'Hello! ';
        $scope.fullName =fullNames.concat(userdetails.fullName);
        console.log("full name");
        });*/
        console.log("after service call");
        /**DEF1802-Regression-MSF applications URLS  are  incorrect **/
        $scope.msfHost = PolicyService.getMsfPortalHost();
        $scope.msfHost.then(function (data) {
            console.log('More link on host basis');
            $scope.hostLink = data;
            /** DEF1667-Regression-MSF Portal Redesgin Integratio **/
            $scope.formsLink = data + '/web/agents/docs/agents-documents-forms.jsf';
        }, function (err) {
            console.error('Error while retrieving MSF host: ', err);
        });
        $scope.getCurrentTime();
    };

    /* Private Functions*/
    function initialiseScopeLevelVariables() {
        $scope.$state = $state;
        $scope.currentState = $state;
        $scope.canCreateSubmission = false;
        checkCreateSubmissionPermission();
        $scope.canViewReports = false;
        checkViewReportsPermission();
        $scope.searchRequest = {
            searchParam: ''
        };
    }

    function checkCreateSubmissionPermission() {
        var permissionDTO = {
            permission: 'createsubmission'
        };
        var permCheckPromise = UserService.hasUserSystemPermission(permissionDTO);
        permCheckPromise.then(function (canCreateSubmission) {
            $scope.canCreateSubmission = canCreateSubmission;
        });
    }

    function checkViewReportsPermission() {
        var reportsConfig = [];
        var CONFIGURATION_PROVIDER = 'AGENT_REPORTS';
        if ($injector.has(CONFIGURATION_PROVIDER)) {
            // Only load the configuration in portals that provide it
            reportsConfig = $injector.get(CONFIGURATION_PROVIDER);
        }
        if (!Array.isArray(reportsConfig) || reportsConfig.length === 0) {
            $scope.canViewReports = false;
            return;
        }
        var permissionDTO = {
            permission: 'gpaviewreports'
        };
        UserService.hasUserSystemPermission(permissionDTO).then(function (canViewReports) {
            $scope.canViewReports = canViewReports && infoCenterFeatureTurnedOn;
        });
    }

    /* Scope Functions*/
    ctrl.setNextState = function () {
        var state = $state.get($state.$current.data.actions.next);
        $state.transitionTo(state);
    };

    ctrl.getType = function () {
        return $stateParams.type;
    };

    ctrl.search = function (searchRequest) {
        var param = $sanitize(searchRequest.searchParam);
        if (param) {
            $state.go('viewSearch', {
                'searchParam': param
            });
        }
    };

    $scope.isActivePage = function (path) {
        return $location.path() === path;
    };

    $scope.sidebarAvailable = function () {
        return ApplicationFeatures.hasFeature('mediasidebar') && $state.is('gatewayLanding');
    };

    $scope.isOnAccountViewState = function () {
        return $state.includes('accounts.detail');
    };

    $scope.getAccountNumberFromStateParams = function () {
        return $stateParams.accountNumber;
    };
    $scope.getCurrentTime = function () {
        var timeZone = "America/Denver";
        var currentServer = moment.tz(timeZone);
        var timeString = serverDown.serverDownTime;
        var eventTime = moment(timeString, 'HH:mm').tz(timeZone);
        var diffTime = eventTime.diff(currentServer, 'seconds');
        var timer = moment.duration(diffTime, 'seconds');
        var interval = 1000;
        var formatTimer = function formatTimer(timer) {
            if (timer.asSeconds() > 0) {
                return zeroPad(timer.minutes(), 2) + ":" + zeroPad(timer.seconds(), 2);
            }
            return "00:00";
        };

        var zeroPad = function zeroPad(num, places) {
            return String(num).padStart(places, '0');
        };
        if (serverDown.featureEnabled) {
            $scope.shutDownTime = undefined;
            $interval(function () {
                timer = moment.duration(timer - interval, 'milliseconds');
                diffTime = timer.asSeconds();
                if (diffTime < -3600) {
                    $scope.shutDownTime = undefined;
                } else if (diffTime < 900) {
                    $scope.shutDownTime = formatTimer(timer);
                }
            }, interval);
        }
    };

    CobrowseIO.customData = {
        user_id: $rootScope.authData.userData.user_name,
        user_name: $rootScope.authData.userData.family_name + ", " + $rootScope.authData.userData.given_name,
        user_email: $rootScope.authData.userData.user_email,
        device_name: $rootScope.authData.userData.family_name + ", " + $rootScope.authData.userData.given_name + " (PartnerConnect)"
    };

    return ctrl.create($scope);
}];


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/directives/NavBarCtrl.js
// module id = 1317
// module chunks = 0